/** Strip all whitespace (spaces, newlines, etc.) for robust DOM matching. */
function normalizeScrollToTextAnchor(s: string): string {
  return s.replace(/\s+/g, "");
}

/**
 * Strip markdown syntax so anchor text matches rendered DOM (e.g. **bold** → bold).
 * Use when building scroll-to-text anchors from raw prompt/content that is rendered as markdown.
 */
export function stripMarkdownForScrollAnchor(text: string): string {
  return text.replace(/\*\*/g, "").replace(/\*/g, "").replace(/__/g, "").replace(/_/g, "").trim();
}

/** Length of start/end anchors. 50 balances uniqueness within one answer vs URL size and matching; increase if we see wrong scroll targets. */
const ANCHOR_CHARS = 50;

/**
 * From raw selected text, produce start and end anchors (normalized, first/last ANCHOR_CHARS).
 * Used for share URLs: we find these anchors in the DOM to scroll and highlight.
 */
export function getScrollToTextAnchors(raw: string): { start: string; end: string } {
  const normalized = normalizeScrollToTextAnchor(raw.trim());
  if (normalized.length <= ANCHOR_CHARS) return { start: normalized, end: normalized };
  return {
    start: normalized.slice(0, ANCHOR_CHARS),
    end: normalized.slice(-ANCHOR_CHARS),
  };
}
